module.exports = __webpack_public_path__ + "img/W-C95.7a055a02.jpg";